import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import GlobalLoaderBar from "./GlobalLoaderBar";
import { resetLoading, setLoadingHandler } from "./loadingBridge";

const LoadingContext = createContext({ isLoading: false, pendingCount: 0 });

export const LoadingProvider = ({ children }) => {
  const [pendingCount, setPendingCount] = useState(0);

  const handleCountUpdate = useCallback((count) => {
    setPendingCount(count);
  }, []);

  useEffect(() => {
    setLoadingHandler(handleCountUpdate);
    return () => {
      setLoadingHandler(null);
      resetLoading();
    };
  }, [handleCountUpdate]);

  const value = useMemo(
    () => ({
      isLoading: pendingCount > 0,
      pendingCount,
    }),
    [pendingCount]
  );

  return (
    <LoadingContext.Provider value={value}>
      <GlobalLoaderBar open={pendingCount > 0} />
      {children}
    </LoadingContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoadingContext;
